import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnSync = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="m17.496 15.426 2.803-.697m0 0L21 17.517m-.7-2.786a9.2 9.2 0 0 1-3.222 4.438A9.3 9.3 0 0 1 11.889 21a8.45 8.45 0 0 1-4.826-1.512 8.37 8.37 0 0 1-3.08-3.992m2.521-6.922-2.803.697m0 0L3 6.484m.7 2.787a9.2 9.2 0 0 1 3.223-4.439A9.3 9.3 0 0 1 12.112 3c1.726 0 3.412.528 4.826 1.512a8.37 8.37 0 0 1 3.08 3.992"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnSync;
